import { getDateInWords } from 'utils/utils';

export const USER_FACING_COPY = {
  addToCart: `Add to Cart`,
  buyFromRetailer: `Buy from Retailer`,
  addedToCart: `Added to Cart`,
  discontinuedProduct: `Discontinued`,
  outOfStock: `Currently Unavailable`,
  outOfStockMessaging: `Sorry, we're currently out of this item. Check out the alternative products below for comparable items.`,
  inventoryAndDeliveryInfo: {
    productIsOutOfStockTitle: 'Currently Unavailable',
    productIsInStockTitle: 'In stock',
    productIsMadeToOrderTitle: 'Made to Order',
    productIsBackOrderedTitle: 'Backordered',
    backOrderedText: (estimatedRestockDate) => `Order now and we'll ship when it's available.\nExpected ${getDateInWords(estimatedRestockDate)}.`,
    showShippingCost: ({ product = null }) => `Shipping: ${product.displayedShippingCost()}`,
    showEstimatedDelivery: ({ product = null }) => `Estimated Delivery: ${product.shippingQuote()}`
  }
};

/**
 * Among all our types of products, we only want a few to show add-ons.
 * Below is the name of each type we want associated to its id.
 */
export const PRODUCT_TYPES_WITH_ADD_ONS = {
  'Wool Tufted & Looped Rugs': 93,
  'Indoor/Outdoor Rugs': 483,
  'Beds': 95,
  // Deprecated but leaving in for BW compatibilty
  'Rug': 93,
  'Bed': 95
};

export const SLIDE_DIRECTIONS = {
  BACK: 'back',
  FORWARD: 'forward',
  SCROLL_LEFT: 'scrollLeft'
};
